import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const useIsCurrentUserCustomerOnboarding = () => {
  const userRole = useCurrentUserAccessRole();

  return userRole === AccessRoleCodes.CustomerOnboarding;
};
